const dateLocale = require('date-fns/locale/de');

export default {
  dateLocale,
};
